import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

type PolicySection = {
  title: string;
  paragraphs?: string[];
  items?: string[];
};

const DataProcessingPolicy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sections = t("legal.dataProcessingPolicy.sections", { returnObjects: true }) as PolicySection[];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4 py-8">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6 flex items-center gap-2 hover:bg-white/80">
          <ArrowLeft className="h-4 w-4" />
          {t("common.backToHome")}
        </Button>

        <main className="max-w-4xl mx-auto">
          <header className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-t-2xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">{t("legal.dataProcessingPolicy.title")}</h1>
            <p className="text-lg opacity-90">{t("legal.dataProcessingPolicy.lastUpdated")}</p>
          </header>

          <div className="bg-white p-6 md:p-8 rounded-b-2xl shadow-lg">
            <div className="prose max-w-none">
              {Array.isArray(sections) && sections.map((section, sectionIndex) => (
                <section className="mb-8" key={`${sectionIndex}-${section.title}`}>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">{section.title}</h2>
                  {section.paragraphs?.map((paragraph, paragraphIndex) => (
                    <p className="text-gray-600 leading-relaxed mb-4 whitespace-pre-line" key={paragraphIndex}>
                      {paragraph}
                    </p>
                  ))}
                  {section.items && section.items.length > 0 && (
                    <ul className="list-disc pl-6 space-y-2 text-gray-600">
                      {section.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
                    </ul>
                  )}
                </section>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DataProcessingPolicy;